import React from "react";
import styled from "styled-components";
import { FlexProps } from "../Flex";
import Flex from "../Flex/Flex";
import { useElementsObserver } from "./hooks/useElementsObserver";
import { VerticalNavigationMenuItem } from "./VerticalNavigationMenuItem";

const Sticky = styled(Flex)<{ $top?: string | number }>`
    position: sticky;
    top: ${({ $top }) => `${$top}${typeof $top === "string" ? "" : "px"}`};
`;

export type VerticalNavigationMenuProps = {
    menuItems: Array<{
        elementId: string;
        hasIssues?: boolean;
        title: string;
    }>;
    top?: string | number;
    flexProps?: FlexProps;
    scrollElementId?: string;
};

export const VerticalNavigationMenu = ({
    menuItems,
    top = 16,
    flexProps = {},
    scrollElementId
}: VerticalNavigationMenuProps) => {
    const { activeElementIds } = useElementsObserver(menuItems.map(item => item.elementId));

    return (
        <Sticky as="nav" column $top={top} {...flexProps}>
            <Flex as="ul" column px={8}>
                {menuItems.map(item => (
                    <VerticalNavigationMenuItem
                        {...item}
                        key={item.elementId}
                        active={activeElementIds.includes(item.elementId)}
                        top={top}
                        scrollElementId={scrollElementId}
                    />
                ))}
            </Flex>
        </Sticky>
    );
};
